import onSearchBoxBlurred from '../actions/onSearchBoxBlurred';
import onSearchBoxFocused from '../actions/onSearchBoxFocused';
import getScenarioStore from '../store/getScenarioStore';
import { mutator } from 'satcheljs';

mutator(onSearchBoxFocused, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).searchBoxHasFocus = true;
});

mutator(onSearchBoxBlurred, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).searchBoxHasFocus = false;
});
